export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 2.a1bb4aaf.jpg";